export const variantStyles = {
  primary: {
    root: 'bg-white/90',
    leftSide: '',
    rightSide: 'sm:contents',
    debtSum: 'text-bronze-50',
    buttons: 'sm:col-span-2'
  },
  secondary: {
    root: 'bg-grey-10',
    leftSide: 'sm:col-span-2',
    rightSide: 'sm:col-span-2 sm:justify-between',
    debtSum: '',
    buttons: ''
  }
}
